import { isNil } from 'shared/src/utils';

export const extractTagInfo = (str: string | null) => {
  if (isNil(str)) {
    return {
      isBold: false,
      isFont: false,
      color: null,
      inner: null,
      tail: null,
    };
  }
  const regex =
    /<([a-zA-Z]+)(?:\s+[^>]*?)?(?:color="([^"]*)")?[^>]*>(.*?)<\/\1>\s*(.*)/i;
  const match = str.match(regex);

  if (!match) {
    return {
      isBold: false,
      isFont: false,
      color: null,
      inner: null,
      tail: null,
    };
  }

  const tag = match[1].toLowerCase();

  return {
    isBold: tag === 'b',
    isFont: tag === 'font',
    color: match[2] || null,
    inner: match[3],
    tail: match[4],
  };
};
